module.exports = __webpack_public_path__ + "static/9-658b4f9735a81c430d6fc56826161c22.jpg";